/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Entity_Id_InvalidInputs */

const cs_audit_entity_id_invalid = /** @type {(inputs: Audit_Entity_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID entity musí být UUID.`)
};

const en_audit_entity_id_invalid = /** @type {(inputs: Audit_Entity_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity id must be a UUID.`)
};

/**
* | output |
* | --- |
* | "Entity id must be a UUID." |
*
* @param {Audit_Entity_Id_InvalidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_entity_id_invalid = /** @type {((inputs?: Audit_Entity_Id_InvalidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Entity_Id_InvalidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_entity_id_invalid(inputs)
	return cs_audit_entity_id_invalid(inputs)
});